import { useTranslation } from "react-i18next";
import { DebugCameraPositionsProps } from "./types";

export const DebugCameraPositions = ({
  startPosition,
  floorPlanAlignment,
}: DebugCameraPositionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Corner reference points */}
      <circle cx="10" cy="10" r="2" fill="yellow" opacity="0.8" />
      <circle cx="390" cy="10" r="2" fill="yellow" opacity="0.8" />
      <circle cx="10" cy="290" r="2" fill="yellow" opacity="0.8" />
      <circle cx="390" cy="290" r="2" fill="yellow" opacity="0.8" />
      {/* Center reference */}
      <circle cx="200" cy="150" r="1" fill="red" opacity="0.8" />
      {/* Start position info */}
      {!!startPosition && (
        <text x="5" y="15" fontSize="8" fill="white" className="font-mono">
          {t("doc_viewer.start_position", {
            x: startPosition.x.toFixed(1),
            y: startPosition.y.toFixed(1),
          })}
        </text>
      )}
      {/* Alignment values */}
      <text x="5" y="285" fontSize="7" fill="white" className="font-mono">
        {t("doc_viewer.offset", {
          x: floorPlanAlignment.offsetX,
          y: floorPlanAlignment.offsetY,
        })}{" "}
        {t("doc_viewer.scale", {
          scale: floorPlanAlignment.scale,
        })}{" "}
        {t("doc_viewer.rotation", {
          rotation: floorPlanAlignment.rotation,
        })}
        °
      </text>
    </>
  );
};
